import {
  FilterOptionKeys,
  GroupByMode,
  SortingMode,
  TaskGroupBy,
} from '@griply/types';

export const todayGroupOptions = [
  GroupByMode.Deadline,
  GroupByMode.Goal,
  GroupByMode.LifeArea,
  GroupByMode.Priority,
  GroupByMode.Type,
  GroupByMode.DayPart,
  GroupByMode.Tag,
] as const satisfies TaskGroupBy[];

export const todaySortOptions = [
  SortingMode.Custom,
  SortingMode.DueDate,
  SortingMode.Priority,
  SortingMode.CreatedAt,
] as const satisfies SortingMode[];

export const todayFilters = [
  FilterOptionKeys.LifeArea,
  FilterOptionKeys.Goal,
  FilterOptionKeys.GoalActive,
  FilterOptionKeys.GoalImpact,
  FilterOptionKeys.Tag,
  FilterOptionKeys.Duration,
  FilterOptionKeys.Priority,
] as const satisfies FilterOptionKeys[];
